import { Navigate, Outlet } from 'react-router-dom';
import { hasAnyRole } from '@v2/lib/auth';

type Props = {
    /** Lista de roles que têm acesso. super_admin sempre passa. */
    roles: readonly string[];
    /** Fallback customizado — padrão é redirecionar para /forbidden */
    fallback?: React.ReactNode;
};

/**
 * Wrapper de rota que verifica se o usuário possui ao menos um dos roles informados.
 * Use como elemento pai de um grupo de <Route> no router.
 *
 * @example
 * <Route element={<RequireRole roles={ADMIN_ROLES} />}>
 *   <Route path="users" element={<UserListPage />} />
 * </Route>
 */
export default function RequireRole({ roles, fallback }: Props) {
    if (!hasAnyRole([...roles])) {
        return fallback ? <>{fallback}</> : <Navigate to="/forbidden" replace />;
    }

    return <Outlet />;
}
